export let itemListProps = {
    key: 0,
    id: 0,
    item_id: null,
    item_detail: {id: 0, sku_code: '', article_name: '', unit_name: ''},
    qty: 1,
    unit_sale_price: 0,
    returned_status: false,
    return_notes: '',
    return_date: new Date(),
    accepted_by_staff_id: null,
    item_edit: 0
}

export let termListProps = {
    key: 0,
    id: 0,
    term_text: ''
}

export let dataProps = {
    id: 0,
    store_id: null,
    challan_number: null, 
    sourcing_date: new Date(), 
    expected_return_date: new Date(), 
    contact_id: null,
    sourced_by_staff_id: null, 
    delivered_by_staff_id: null, 
    delivery_notes: '',
    additional_notes: '',
    status: 0, 
    
    item_list: [JSON.parse(JSON.stringify(itemListProps))],
    term_list: [JSON.parse(JSON.stringify(termListProps))],
}


// WEBPACK FOOTER //
// ./src/store/modules/inventorySourcing/properties.js